import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';

import * as graphql from '@treams/treams-network';
import { Modal, Paragraph, Radio } from '@treams/treams-ui';

export default function CreateTeamRole(props: {
	source: graphql.User;
	target: graphql.Group;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	refetch: () => Promise<any>;
	onCancel: () => void;
	onCreate: () => void;
}) {
	const { t } = useTranslation();

	const [role, setRole] = useState<graphql.RoleType>(graphql.RoleType.Owner);

	const [create] = graphql.useAssignRoleMutation();

	const roleIDs: Partial<Record<graphql.RoleType, string>> = {
		[graphql.RoleType.Owner]: 'group-owner',
		[graphql.RoleType.Collaborator]: 'group-collaborator',
		[graphql.RoleType.Member]: 'group-member',
	};

	return (
		<Modal width={400}>
			<Modal.Contents>
				<Paragraph mb={3}>{t('settings.employees.roles.create.user.instruction')}:</Paragraph>
				<Flex mb={3} onClick={() => setRole(graphql.RoleType.Owner)}>
					<Box flexGrow={0} flexShrink={0} mr={2}>
						<Radio
							checked={role === graphql.RoleType.Owner}
							onChange={() => setRole(graphql.RoleType.Owner)}
						/>
					</Box>
					<Box>
						<Paragraph>
							{t('settings.employees.roles.create.explanations.team.owner', {
								source: `${props.source.firstName} ${props.source.lastName}`,
								target: props.target.name,
							})}
							.
						</Paragraph>
					</Box>
				</Flex>
				<Flex onClick={() => setRole(graphql.RoleType.Collaborator)}>
					<Box flexGrow={0} flexShrink={0} mr={2}>
						<Radio
							checked={role === graphql.RoleType.Collaborator}
							onChange={() => setRole(graphql.RoleType.Collaborator)}
						/>
					</Box>
					<Box>
						<Paragraph>
							{t('settings.employees.roles.create.explanations.team.collaborator', {
								source: `${props.source.firstName} ${props.source.lastName}`,
								target: props.target.name,
							})}
							.
						</Paragraph>
					</Box>
				</Flex>
			</Modal.Contents>
			<Modal.FormFooter
				small
				onCancel={props.onCancel}
				onSave={async () => {
					await create({
						variables: {
							input: {
								targetID: props.target.id,
								targetType: graphql.RoleTargetType.Team,
								isIndirect: false,
								roleID: roleIDs[role!]!,
								userID: props.source.id,
							},
						},
					});
					await props.refetch();
					props.onCreate();
				}}
				disabled={role === undefined}
			/>
		</Modal>
	);
}
